import script from "./OEvento.vue?vue&type=script&lang=ts&setup=true"
export * from "./OEvento.vue?vue&type=script&lang=ts&setup=true"

import "./OEvento.vue?vue&type=style&index=0&id=6e15b1de&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e15b1de"]])

export default __exports__